<script>
  import { createEventDispatcher } from "svelte";
  // import iconPlay from "../assets/icons/play.svg";
  // import iconStop from "../assets/icons/stop.svg";
  import Loader from "./Loader.svelte";
  import Play from "../icons/play2.svelte";
  import Pause from "../icons/pause2.svelte";
  import { getGlobalContext } from "../util/audio-players";

  const dispatch = createEventDispatcher();

  export let playing = false;
  export let loading = false;
  export let padded = false;
</script>

<div
  class="play-button"
  role="none"
  class:padded
  on:click={async (ev) => {
    ev.preventDefault();
    if (!loading) {
      dispatch("click", ev);
    }
  }}
  alt="Play or Pause"
>
  {#if loading}
    <div class="loader"></div>
  {:else if playing}
    <Pause></Pause>
    <!-- <svg
      class:playing
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="65" height="65" fill="currentColor" />
    </svg> -->
  {:else}
    <Play></Play>
    <!-- <svg
      width="56"
      height="65"
      viewBox="0 0 56 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Button: PLAY"
        d="M55.5 32.0429L-2.80128e-06 64.0859L0 -2.42598e-06L55.5 32.0429Z"
        fill="currentColor"
      />
    </svg> -->
  {/if}
</div>

<style>
  .play-button {
    width: 100%;
    height: 100%;
    cursor: pointer;
    color: black;
    display: flex;
    /* background: hsl(0, 0%, 85%); */
    border-radius: 1px;
    justify-content: center;
    box-sizing: border-box;
    padding: 8px;
    transform: translateZ(0);
    align-items: center;
    overflow: hidden;
    /* padding: 8px; */
  }
  .padded {
    /* padding: 8px; */
  }
  /* svg {
    color: black;
    height: 100%;
    width: auto;
    position: relative;
    left: 2px;
  }

  svg.playing {
    position: relative;
    aspect-ratio: 1;
    left: 0px;
  } */

  .loader {
    /* width: 100%; */
    margin-left: -2px;
    /* height: 100%; */
    height: 20px;
    width: 20px;
    aspect-ratio: 1;
    /* padding: 2px; */
    /* width: 30px; */
    /* height: 65px; */
    will-change: transform;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid #000;
    animation:
      l20-1 0.8s infinite linear alternate,
      l20-2 1.6s infinite linear;
  }
  @keyframes l20-1 {
    0% {
      clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
    }
    12.5% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 0%,
        100% 0%,
        100% 0%
      );
    }
    25% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 100%,
        100% 100%,
        100% 100%
      );
    }
    50% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    62.5% {
      clip-path: polygon(
        50% 50%,
        100% 0,
        100% 0%,
        100% 0%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    75% {
      clip-path: polygon(
        50% 50%,
        100% 100%,
        100% 100%,
        100% 100%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    100% {
      clip-path: polygon(
        50% 50%,
        50% 100%,
        50% 100%,
        50% 100%,
        50% 100%,
        50% 100%,
        0% 100%
      );
    }
  }
  @keyframes l20-2 {
    0% {
      transform: scaleY(1) rotate(0deg);
    }
    49.99% {
      transform: scaleY(1) rotate(135deg);
    }
    50% {
      transform: scaleY(-1) rotate(0deg);
    }
    100% {
      transform: scaleY(-1) rotate(-135deg);
    }
  }
</style>
